import {StyleSheet} from 'react-native';

import {cloudLight, grayscale} from '/theme/color/on.color';
import {codGray, denim} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {},

  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 1,
  },

  footerButtons: {
    paddingTop: 20,
    marginBottom: 0,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    alignItems: 'center',
  },

  footerButtonPaddingIos: {
    paddingBottom: 20,
  },

  footerButtonPaddingAndroid: {},

  starIcon: {
    fontSize: 24,
    marginLeft: 6,
  },

  wishList: {
    color: denim,
  },

  wishListButtonText: {
    color: denim,
    marginLeft: 8,
  },

  UnwishListButtonText: {
    color: codGray,
    marginLeft: 8,
    width: '100%',
    paddingTop: 5,
  },

  watchListButtonTextWeb: {
    width: 'auto',
    paddingTop: 0,
  },

  UnwishList: {
    color: grayscale,
  },

  ButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
  },

  ButtonContainerLandscape: {
    alignSelf: 'center',
  },

  watchListButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    height: 34,
    borderRadius: 8,
    borderWidth: 1,
    width: '50%',
  },

  watchListButtonWeb: {
    width: 'auto',
    minWidth: 168,
  },

  watchListButtonPortraitSpacing: {
    marginLeft: 16,
  },

  onWatchlistButton: {
    backgroundColor: '#EEF4FC',
    borderWidth: 1,
    borderColor: '#1D5BBF',
    color: 'back',
    width: 170,
  },

  removeWatchListButton: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#D1D1D1',
    color: 'red',
  },

  viewProfileButton: {
    marginRight: 0,
  },

  singleViewProfileLandscape: {
    minWidth: 220,
    minHeight: 44,
    paddingVertical: 12,
    alignSelf: 'center',
  },

  volumePerformanceButton: {
    marginBottom: 10,
    alignSelf: 'flex-start',
    borderRadius: 8,
  },

  volumePerformanceButtonText: {
    color: denim,
    fontSize: 13,
    fontWeight: '600',
  },
});
